export function calculateBrokerage(broker, tradeType, buyValue, sellValue, quantity) {
  const isDelivery = tradeType === "delivery";
  const brokerage = isDelivery ? 0 : Math.min(20, 0.0003 * (buyValue + sellValue));
  const stt = isDelivery ? (buyValue + sellValue) * 0.001 : sellValue * 0.00025;
  const exc = (buyValue + sellValue) * 0.0000322;
  const gst = (brokerage + exc) * 0.18;
  const sebi = (buyValue + sellValue) * 0.000001;
  const stamp = isDelivery ? buyValue * 0.00015 : buyValue * 0.00003;
  const dp = isDelivery && sellValue > 0 ? 15.93 : 0;
  const total = brokerage + stt + exc + gst + sebi + stamp + dp;
  const r = n => Math.round(n * 100) / 100;
  const result = { brokerage: r(brokerage), stt: r(stt), exchange: r(exc), gst: r(gst), sebi: r(sebi), stamp: r(stamp), dp: r(dp), total: r(total) };
  return broker === "Both" ? { Zerodha: result, Dhan: result } : { [broker]: result };
}
